import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import LoopFramework from "@/components/landing/LoopFramework";
import Problem from "@/components/landing/Problem";
import WhyTraditionalFails from "@/components/landing/WhyTraditionalFails";
import WhatIsAdaptive from "@/components/landing/WhatIsAdaptive";
import NervousSystem from "@/components/landing/NervousSystem";
import WhyExercise from "@/components/landing/WhyExercise";
import Framework from "@/components/landing/Framework";
import WhoThisHelps from "@/components/landing/WhoThisHelps";
import CompanionDownload from "@/components/landing/CompanionDownload";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";

const Landing = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
      });
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [pathname, hash]);

  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen forr-canvas forr-text-ink overflow-x-hidden"
    >
      <div className="forr-grain" aria-hidden="true" />
      <Header />
      <Hero />
      <LoopFramework />
      <Problem />
      <WhyTraditionalFails />
      <WhatIsAdaptive />
      <NervousSystem />
      <WhyExercise />
      <Framework />
      <WhoThisHelps />
      <CompanionDownload />
      <CTA />
      <Footer />
    </main>
  );
};

export default Landing;
